import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Route, Switch, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { CSVLink } from "react-csv";
import currency from "currency.js";
import moment from "moment";
import { Dropdown } from "react-bootstrap";

import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { URLS } from "../urls";
import { Row } from "reactstrap";
import Loader from "../Loader";
import { branch_id } from "../../utils";
import { PDFIcon, ExcelIcon, ExportIcon } from "../icons";
import { useDownloadExcel } from "../useDownloadExcel";
import SentToAccount from "./SendToAccount";

function SalarySummary() {
  const date = new Date();
  const [payrollDate, setPayrollDate] = useState({
    payrollMonth: date.getMonth() + 1,
    payrollYear: date.getFullYear(),
  });

  const [isLoading, setIsLoading] = useState(false);

  const [payroll, setPayroll] = useState([]);
  const [totalNetpay, setTotalNetPay] = useState(0);
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [salaryDetails, setSalaryDetails] = useState([]);

  const [excelData, setExcelData] = useState([]);

  const CSVLinkRef = useRef(null);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  useEffect(() => {
    getPayroll();

    return () => {};
  }, [payrollDate]);

  useEffect(() => {
    getSalarydetails(date.getMonth() + 1, date.getFullYear());
  }, []);

  async function getPayroll() {
    try {
      setIsLoading(true);
      const token = "dummy token";
      const payrollResonse = await fetch(
        `${URLS.backendPayroll}/get-payroll/${branch_id}?payrollMonth=${payrollDate.payrollMonth}&payrollYear=${payrollDate.payrollYear}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      const payrollResult = await payrollResonse.json();
      const { payroll } = payrollResult;
      if (payroll.length) {
        payroll.map((el) => {
          setTotalNetPay((g) => currency(g).add(el.netPay));
        });

        setPayroll(payroll);
      } else {
        setPayroll([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }
  // console.log(salaryDetails);
  const getSalarydetails = async (month, year) => {
    const token = "dummy token";
    fetch(`${URLS.backendSalary}/single/${month}/${year}/${branch_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setSalaryDetails(result.salary);
      });
  };

  const onDownloadExcelData = async () => {
    let exData = payroll.map((employee, index) => [
      index + 1,
      employee.netPay,
      employee.debitAccountNo,
      employee.debitBankCode,
      employee.creditAccountNo,
      employee.creditBankCode,
      employee.user?.personalInfo?.name.first +
        " " +
        employee.user?.personalInfo?.name.last,
      new Date(employee.createdAt).toDateString(),
      ` ${employee.payrollMonth + " " + employee.payrollYear} Salary`,
    ]);

    const normalHead = [
      "No",
      "Net Amount",
      "Debit Account No",
      "Debit Bank Code",
      "Credit Account No",
      "Credit Bank Code",
      "Beneficiary",
      "Payment Date",
      "Narration",
    ];

    const date = `Date Prepared: ${moment(new Date()).format(
      "MMMM DD yyyy k:mm:ss z"
    )}`;

    exData = [
      // [company],
      ["Payment History Report"],
      [date],
      [""],
      normalHead,
      ...exData,
      [""],
      ["Salary Summary"],
      [
        "Total Net Amount",
        currency(totalNetpay, {
          symbol: "",
        }).format(),
      ],
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>Invex ERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="row">
              <div className="col-sm-12 col-12 text-capitalize">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <Link to={`${URLS.dashboard}`}>Dashboard</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>Salary Schedule</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <div className="col-sm-5 col-5"></div>
              {/*<div className="col-sm-7 col-7 text-right m-b-30"></div>*/}
            </div>
            {/*<!-- /Page Title -->*/}
            {/*<!-- Content Starts -->*/}
            <div className="mt-3">
              <div className="d-flex justify-content-between my-4">
                <div className="d-flex">
                  <div className="form-inline">
                    <label>Month</label>
                    <select
                      className="form-control mx-2"
                      value={payrollDate.payrollMonth}
                      onChange={(e) => {
                        setPayrollDate({
                          payrollMonth: e.target.value,
                          payrollYear: payrollDate.payrollYear,
                        });
                      }}
                    >
                      {[...Array(12)].map((e, index) => (
                        <option key={index}>{index + 1}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-inline ml-3">
                    <label>Year</label>
                    <input
                      type="number"
                      style={{ width: "100px" }}
                      className="form-control mx-2"
                      value={payrollDate.payrollYear}
                      onChange={(e) => {
                        setPayrollDate({
                          payrollMonth: payrollDate.payrollMonth,
                          payrollYear: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="form-inline">
                    <select
                      className="form-control"
                      aria-label="Default select example"
                    >
                      <option selected>Select Payment Bank</option>
                      <option value="GTBank">GTBank</option>
                      <option value="Access Bank">Access Bank</option>
                      <option value="Zenith Bank">Zenith Bank</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  {salaryDetails?.status && (
                    <button className="print mx-3">
                      {salaryDetails?.status}
                    </button>
                  )}

                  {salaryDetails?.length < 1 ||
                    (salaryDetails?.status === "Disapproved" && (
                      <button
                        className="print-primary"
                        data-toggle="modal"
                        data-target="#add_leave"
                      >
                        Request for Payment
                      </button>
                    ))}

                  <div className="mx-4">
                    <CSVLink
                      className="btn print d-none"
                      filename={`SalarySummary(${moment(new Date()).format(
                        "DD-MMM-yyyy hh:mm:ss a"
                      )}).csv`}
                      data={excelData}
                      ref={CSVLinkRef}
                    />

                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        <span className="mx-2">Export</span>
                        <ExportIcon color="#008000" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelData}
                          className="p-cursor"
                        >
                          Excel <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                        {/* <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/reports/pdf/sales-analysis?${queryString.stringify(
                              newQuery
                            )}`}
                            target="blank"
                          >
                            PDF
                            <PDFIcon color="#ff0000" />
                          </a>
                        </Dropdown.Item> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>

              <Row className="m-0">
                {isLoading && <Loader />}
                {payroll.length ? (
                  <div className="col-md-12 w-100">
                    <div className="table-responsive">
                      <table className="table table-striped custom-table mb-0 datatable">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Net Amount</th>
                            <th>Debit Account No</th>
                            <th>Debit Bank Code</th>
                            <th>Credit Account No</th>
                            <th>Credit Bank Code</th>
                            <th>Beneficiary</th>
                            <th>Payment Date</th>
                            <th>Narration</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payroll.map((employee, index) => {
                            return (
                              <tr Key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {currency(employee.netPay, {
                                    symbol: "",
                                  }).format()}
                                </td>
                                <td>{employee.debitAccountNo}</td>
                                <td>{employee.debitBankCode}</td>
                                <td>{employee.creditAccountNo}</td>
                                <td>{employee.creditBankCode}</td>
                                <td>
                                  {employee.user?.personalInfo?.name.first +
                                    " " +
                                    employee.user?.personalInfo?.name.last}
                                </td>
                                <td>
                                  {new Date(employee.createdAt).toDateString()}
                                </td>
                                <td>
                                  {employee.payrollMonth +
                                    " " +
                                    employee.payrollYear}{" "}
                                  Salary
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div
                    className="w-100 d-flex justify-content-center align-items-center bg-white"
                    style={{ height: "250px" }}
                  >
                    <p>No Payroll processed</p>
                  </div>
                )}
              </Row>
            </div>

            <div
              className={
                btnSummryActive
                  ? `summaryNew border-top open`
                  : `summaryNew border-top`
              }
            >
              <div className="row justify-content-between mt-4">
                <div className="col">
                  <div className="my-3">
                    <div className="d-flex gap-3 align-items-center mb-4">
                      <h4 className="m-0">Total Net Amount</h4>{" "}
                      <hr className="flex-grow-1 m-0" />
                      {btnSummryActive && (
                        <button
                          onClick={() => setBtnSummaryActive(!btnSummryActive)}
                          className="btn p-0"
                        >
                          {/* <SummaryCloseIcon /> */}
                        </button>
                      )}
                    </div>

                    <div
                      className="gridCont mb-3 three-col-grid"
                      style={{ gridTemplateRows: "unset" }}
                    >
                      {/*  */}
                      <div className="gridChild gridChildBorderLeftBlue">
                        <div className="gridChildLeft">
                          <p className="gridChld1">
                            {currency(totalNetpay, {
                              symbol: "",
                            }).format()}
                          </p>
                          <p className="gridChld2">Total Net Amount</p>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*<!-- /Content End -->*/}
          </div>
          {/*<!-- /Page Content -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}

        {payroll.length && (
          <SentToAccount
            payrollDate={payrollDate}
            Amount={currency(totalNetpay, {
              symbol: "",
            }).format()}
          />
        )}
      </div>
      {/*<!-- /Page Wrapper -->*/}
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
}

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
    // deductionSettings: state.deductionSettings.deductions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SalarySummary));
